import { render } from "./EditAuth.vue?vue&type=template&id=08ccafca&scoped=true"
import script from "./EditAuth.vue?vue&type=script&lang=js"
export * from "./EditAuth.vue?vue&type=script&lang=js"

import "./EditAuth.vue?vue&type=style&index=0&id=08ccafca&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08ccafca"]])

export default __exports__